import React from 'react';
import { Link } from 'react-router-dom';
import Util from '../../../Util';

const DoctorAvatar = (props) => {
    return (  
        <h6 className="table-avatar">
            <Link className="avatar avatar-sm mr-2" 
            to={
                    {
                        pathname:'/profile',
                        state: {
                            user: props.doctor,
                            userType: 'doctor'
                        }
                    }
                }><img className="avatar-img rounded-circle" src={Util.loadImage(props.doctor.profileImage)}  alt="User Image" /> </Link>
            <Link 
            to={
                    {
                        pathname:'/profile',
                        state: {
                            user: props.doctor,
                            userType: 'doctor'
                        }
                    }
                }>Dr. {props.doctor.firstName} {props.doctor.lastName}</Link>
        </h6>
    );
}
 
export default DoctorAvatar;